import apiClient from '../config/api';

const breakdownLogService = {
  /**
   * Get all breakdown logs
   * @param {number} machineId - Optional machine ID filter
   * @param {Date} startDate - Optional start date filter
   * @param {Date} endDate - Optional end date filter
   * @returns {Promise} Array of breakdown logs
   */
  getBreakdownLogs: async (machineId = null, startDate = null, endDate = null) => {
    const params = {};
    if (machineId) params.machineId = machineId;
    if (startDate) params.startDate = startDate.toISOString();
    if (endDate) params.endDate = endDate.toISOString();
    
    const response = await apiClient.get('/breakdownlog', { params });
    return response.data;
  },

  /**
   * Get breakdown log by ID
   * @param {number} breakdownLogId - Breakdown log ID
   * @returns {Promise} Breakdown log details
   */
  getBreakdownLogById: async (breakdownLogId) => {
    const response = await apiClient.get(`/breakdownlog/${breakdownLogId}`);
    return response.data;
  },

  /**
   * Get breakdown logs by machine
   * @param {number} machineId - Machine ID
   * @param {Date} startDate - Optional start date filter
   * @param {Date} endDate - Optional end date filter
   * @returns {Promise} Array of breakdown logs
   */
  getBreakdownLogsByMachine: async (machineId, startDate = null, endDate = null) => {
    const params = {};
    if (startDate) params.startDate = startDate.toISOString();
    if (endDate) params.endDate = endDate.toISOString();
    
    const response = await apiClient.get(`/breakdownlog/machine/${machineId}`, { params });
    return response.data;
  },

  /**
   * Create breakdown log
   * @param {object} breakdownLogData - Breakdown log data
   * @returns {Promise} Created breakdown log
   */
  createBreakdownLog: async (breakdownLogData) => {
    const response = await apiClient.post('/breakdownlog', breakdownLogData);
    return response.data;
  },

  /**
   * Update breakdown log
   * @param {number} breakdownLogId - Breakdown log ID
   * @param {object} breakdownLogData - Updated breakdown log data
   * @returns {Promise} Updated breakdown log
   */
  updateBreakdownLog: async (breakdownLogId, breakdownLogData) => {
    const response = await apiClient.post(`/breakdownlog/update/${breakdownLogId}`, breakdownLogData);
    return response.data;
  },

  /**
   * Delete breakdown log
   * @param {number} breakdownLogId - Breakdown log ID
   * @returns {Promise} Deletion result
   */
  deleteBreakdownLog: async (breakdownLogId) => {
    const response = await apiClient.post(`/breakdownlog/delete/${breakdownLogId}`);
    return response.data;
  },
};

export default breakdownLogService;

